import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import TierFeature from './tierFeature'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import FormError from '~/Common-Objects/UI/Forms/FormError/FormError'
import Icons from '~/Common-Objects/UI/Icons/index'
import Select from '~/Common-Objects/UI/Forms/Select/Select'
import FormatNumberFuncs from '~/Classes/numberFormatFunctions'
import axios from '~/data/http/axios'
import UpgradeDrawerTiers from '~/pages/cp/includes/upgrade/upgradeTiers'
import UpgradeDrawer from '~/pages/cp/includes/upgrade/upgrade'
import { alterFullpage, alterSiteDrawer } from '~/data/actions/siteActions'

export default function Sms(account, plans = [], onUpgrade = () => {}) {
    const [plan, setPlan] = useState(plans[0]?.id)
    const [error, setError] = useState(null)
    const [paying, setPaying] = useState(false)
    const history = useHistory()
    const dispatch = useDispatch()
    const site = useSelector((state) => state.siteMaster)

    const purchase = async () => {
        setError(null)
        setPaying(true)
        try {
            const res = await axios.put('/accountMaster/plan/sms', {
                planId: plan
            })
            if (res.data.success) {
                onUpgrade()
            } else {
                setError(res.data.error)
            }
        } catch (e) {
            setError(e.message)
        }
        setPaying(false)
    }

    const submitInterestedIn = async () => {
        await axios.post('/accountuser/feedback', {
            type: 'sms',
            campaignTypeInterestedIn: 'sms'
        })
        onUpgrade()
    }

    const changePlan = async () => {
        var drawerContent = (
            <UpgradeDrawer
                close={() => {
                    dispatch(alterSiteDrawer(false, true, 'right', null))
                }}
            />
        )

        if (account.billedOnContacts || site.siteId === 1) {
            drawerContent = (
                <UpgradeDrawerTiers
                    history={history}
                    close={() => {
                        dispatch(alterSiteDrawer(false, true, 'right', null))
                    }}
                />
            )
        }

        dispatch(alterSiteDrawer(true, true, 'right', drawerContent, true, '1000px'))
        dispatch(alterFullpage(null))
    }

    const selectedPlan = plans.find((p) => p.id === plan)
    let price
    if (selectedPlan) {
        price = selectedPlan.price + '/' + (account.billingFrequency === 0 ? 'month' : 'year')
        if (account.billingFrequency === 1) {
            // annual so times it by 12
            price = selectedPlan.price * 12 + '/year'
        }
    }

    const isUk = account.country === 'United Kingdom' || account.options?.allowSms

    const isPaid = account.accountType === 'paid'

    const headerStyle = {
        fontWeight: 600,
        fontStyle: 'Semi Bold',
        fontSize: '20px',
        leadingTrim: 'NONE',
        lineHeight: '26px',
        letterSpacing: '-0.4px',
        marginBottom: 8
    }
    const contentStyle = {
        fontWeight: 400,
        fontStyle: 'Regular',
        fontSize: '13px',
        leadingTrim: 'NONE',
        lineHeight: '20px',
        letterSpacing: 0,
        color: 'var(--neutral-800)'
    }

    return {
        topTaster: 'Text your way to better results.',
        header: (
            <div>
                Subscribe to <span style={{ color: 'var(--purple-600' }}>SMS</span> today and boost your engagement
            </div>
        ),
        image: 'https://cdn1.ourmailsender.com/siteContent/assets/upsell/sms-addon-2.png',
        content: (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                <div
                    style={{
                        fontWeight: 400,
                        fontStyle: 'Regular',
                        fontSize: '13px',
                        leadingTrim: 'NONE',
                        lineHeight: '20px',
                        letterSpacing: '-0.1px'
                    }}
                >
                    Send targeted SMS campaigns to your contacts, ensuring your messages are seen and acted upon
                    quickly. Perfect for time-sensitive offers and updates.
                </div>

                <div className='upsellModal__tier__features'>
                    <TierFeature name='Send personalised, targeted messages' />
                    <TierFeature name='Built-in opt-out and compliance' />
                    <TierFeature name='Seamlessly integrate into your existing Automations' />
                </div>
            </div>
        ),
        customCta: true,
        customRightPanel: (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
                <div>
                    <div style={headerStyle}>
                        {isUk
                            ? isPaid
                                ? 'Monthly SMS Credits'
                                : 'Upgrade to a paid Transpond plan'
                            : 'SMS is currently only available in the UK'}
                    </div>
                    {isUk && isPaid && (
                        <div style={contentStyle}>
                            Select the amount you need. You can always upgrade if you need more whenever you need.
                        </div>
                    )}
                    {isUk && !isPaid && (
                        <div style={contentStyle}>
                            You'll need to upgrade to a paid plan before you can activate SMS. <br />
                            <br />
                            Once upgraded, you'll be able to choose your SMS credit subscription and start sending
                            straight away.
                        </div>
                    )}
                    {!isUk && (
                        <div style={contentStyle}>
                            Right now, SMS campaigns can only be activated on accounts with a UK billing address. <br />{' '}
                            <br />
                            However, if your contacts are based in the UK, we may still be able to enable SMS for your
                            account.
                        </div>
                    )}
                </div>
                {isUk && isPaid && (
                    <>
                        <Select
                            data={plans.map((p) => ({
                                label: `${p.symbol}${p.friendlyPriceRaw} ${account.addVAT ? ' + VAT' : ''} (${FormatNumberFuncs.formatNumber(p.maxUniqueSends)} Credits)`,
                                value: p.id
                            }))}
                            value={plan}
                            onChange={(e) => setPlan(e.target.value)}
                        />
                        <div>
                            <Button
                                className='button-primary button-fullwidth'
                                iconLeft={
                                    <Icons
                                        icon={!paying ? 'upgradeChevrons' : 'loading'}
                                        style={{ width: 16, height: 16 }}
                                    />
                                }
                                onClick={purchase}
                                disabled={paying || !plan}
                                postHogTag='sms-upsell-add'
                            >
                                Add SMS for {selectedPlan?.symbol}
                                {price}
                            </Button>
                            {!!error && <FormError>{error}</FormError>}
                        </div>
                        <div style={contentStyle}>
                            By clicking the “Add” button above, you agree to our{' '}
                            <a href='https://transpond.io/sms_terms' target='_blank'>
                                Terms and Conditions
                            </a>{' '}
                            of use. Your new subscription will begin immediately. <br />
                            <br />
                            Future payments will reflect the full price of your selected plan. You can change or cancel
                            your plan at any time.
                        </div>
                    </>
                )}
                {isUk && !isPaid && (
                    <div>
                        <Button className='button-primary button-fullwidth' onClick={changePlan}>
                            Choose your plan
                        </Button>
                    </div>
                )}
                {!isUk && (
                    <>
                        <Button className='button-primary button-fullwidth' onClick={submitInterestedIn}>
                            Notify me when available
                        </Button>
                        <div style={contentStyle}>
                            However, if your contacts are based in the UK, we may still be able to enable SMS for your
                            account.
                        </div>
                        <Button className='button-fullwidth' href='https://transpond.io/support' target='_blank'>
                            Contact Support
                        </Button>
                    </>
                )}
            </div>
        )
    }
}
